import { Layout } from "react-admin";
import { CustomMenu } from "./Menu";

export const CustomLayout = (props: any) => (
  <Layout {...props} menu={CustomMenu} />
);
